import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-green-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <rect x="4" y="4" width="16" height="6" fill={textColor} />
    <rect x="4" y="10" width="11" height="5" fill={textColor} />
    <rect x="4" y="15" width="6" height="5" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <rect x="8" y="7.27295" width="16" height="5.81818" fill={textColor} />
    <rect x="8" y="13.0908" width="10.9091" height="5.81818" fill={textColor} />
    <rect x="8" y="18.9092" width="5.81818" height="5.81818" fill={textColor} />
  </>
);

export const RankingIcon = createSlideIcon(Icon24x24, Icon32x32);
